var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirmation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 237,
    height: 198,
    viewBox: "0 0 237 198",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 99,
    cy: 99,
    r: 99,
    fill: "#100A55"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.211 123.161L68.3516 90.0203",
    stroke: "#F5F9FE",
    strokeWidth: 28,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.294 108.951L216.211 17.7704L119.157 131.528L100.294 108.951Z",
    fill: "#F5F9FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmation);
export default __webpack_public_path__ + "static/media/confirmation.1c77b5ee8f6da7eac4335c324fbf4730.svg";
export { ForwardRef as ReactComponent };